

































































import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
import { AxiosResponse, AxiosError } from 'axios'
import Cookies from "js-cookie";
import PrettyCheck from 'pretty-checkbox-vue/check';


Vue.component('p-check', PrettyCheck);

@Component({
  components: {}
})
export default class Profiles extends Vue {

  private newObf = {
    id: null,
    text: "Create or select a profile",
    name: "",
    ignored_files: "",
    files_not_encrypted: "",
    block_editor: true,
    encryption_key: "1,2,3,4",
    config_obfuscation: false
  };

  private obfuscation = this.newObf;

  private profiles = [];

  private selected() {
    console.log(this.obfuscation.block_editor);
    if (typeof this.obfuscation.block_editor != "boolean") {
      this.obfuscation.block_editor = this.obfuscation.block_editor == "true";
    }
    console.log(this.obfuscation.block_editor);
  }

  private async created() {
    let response = await axios.post('https://sqfsafe.com/api/obfuscation/list-profiles');
    let data = response.data;

    if (data.success) {
      this.profiles = data.profiles;

      this.profiles.unshift(this.newObf);
    } else {
      alert("Error loading existing profiles, try refreshing the page");
    }
  }

  private generateEncryption() {
    let amount = Math.floor(Math.random() * 48) + 24;
    let enc = [];

    for (let i = 0; i < amount; i++) {
      enc.push(Math.floor(Math.random() * 900) + 50);
    }

    this.obfuscation.encryption_key = enc.join(',');
  }

  private async saveProfile() {
    if (this.obfuscation.name == "") {
      alert("The profile name cannot be empty!");
      return;
    }
    
    let response = await axios.post('https://sqfsafe.com/api/obfuscation/save-profile', this.obfuscation);
    let data = response.data;

    if (data.success) {
      alert("Your profile was saved successfully!");
      this.obfuscation = this.newObf;
    } else {
      alert("Failed to save your profile? Are you still logged in?");
    }
  }
  
}
